"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return IRManager;
    }
});
const _temperatureUnitsEnum = /*#__PURE__*/ _interop_require_default(require("../../enums/temperatureUnitsEnum.js"));
const _utilities = require("../../utilities");
const _enums = require("../lib/enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const DEFAULT_PALETTE_DATA = {
    paletteNames: [],
    paletteAliases: {},
    palettePrettyNamesMap: {},
    paletteGradients: {},
    paletteGradient: null
};
class IRManager {
    setLoadedData(data = []) {
        this.loadedData = data;
    }
    updateLoadedData(index, id, file) {
        const next = this.loadedData.slice();
        next[index] = _object_spread_props(_object_spread({}, next[index]), {
            id,
            file
        });
        this.loadedData = next;
    }
    getSettingsFromJSON(json = {}) {
        let curSettings = {};
        if (Object.keys(json).length > 0) {
            curSettings = (0, _utilities.unpackImageInfo)(json, this.temperatureUnits);
        }
        return curSettings;
    }
    refreshSettings() {
        this.loadSettingsById(this.visibleImages[0]);
    }
    updateSettings(nextSettings = {}) {
        if (Object.keys(nextSettings).length < 1) return;
        const prevSettings = this.getSettings();
        const next = _object_spread({}, prevSettings, nextSettings);
        // are we in batch edit mode
        if (this.visibleImages.length > 1) {
            // Remove specific keys from nextSettings during batch edit
            delete next[_enums.ValidSettings.TEXTNOTES];
            delete next[_enums.ValidSettings.OCR_TEXT];
            delete next[_enums.ValidSettings.ASSET_TAG];
            delete next[_enums.ValidSettings.REFERENCE_MARKER_ID];
            delete next["MARKERS"];
        }
        this.settings = next;
    }
    updateGroupImageData(id = "", payload = {}) {
        if (!id || Object.keys(payload).length < 1) return;
        const prev = _object_spread({}, this.groupImageData);
        this.groupImageData = _object_spread_props(_object_spread({}, prev), {
            [id]: _object_spread({}, prev[id], payload)
        });
    }
    getImageDataById(id = "") {
        var _this_groupImageData;
        return ((_this_groupImageData = this.groupImageData) === null || _this_groupImageData === void 0 ? void 0 : _this_groupImageData[id]) || {};
    }
    loadSettingsById(id = "") {
        const imageData = this.getImageDataById(id);
        if (Object.keys(imageData).length < 1) return;
        // set palette data -->
        const paletteData = imageData.PALETTE_DISPLAY_DATA;
        if (paletteData && Object.keys(paletteData)) {
            this.paletteData = paletteData;
        }
        const { DATA = {} } = imageData !== null && imageData !== void 0 ? imageData : {};
        const { json = {}, photonotes = [] } = DATA;
        if (Object.keys(json).length < 1) return;
        const nextSettings = this.getSettingsFromJSON(json);
        this.updateSettings(nextSettings);
        this.photonotes = photonotes;
    }
    handleIRViewerPayload(payload = {}) {
        // callback from the irviewer component
        const { DATA: { id = "" } = {} } = payload;
        this.updateGroupImageData(id, payload);
        if (id === this.visibleImages[0]) {
            this.loadSettingsById(id);
        }
    }
    setVisibleImages(nextImages = []) {
        this.visibleImages = nextImages;
        this.refreshSettings();
    }
    getSortedImages() {
        const loadedData = this.loadedData.slice();
        if (!loadedData || !Array.isArray(loadedData) || !this.visibleImages) return [];
        const dataIsValid = (data)=>{
            return data != null && Object.keys(data).length > 1 && data.id;
        };
        // Filter out null or undefined entries from loadedData
        const nextSort = loadedData.filter(dataIsValid);
        // Add 'visible' key to each object in nextSort
        nextSort.forEach((image)=>{
            image.visible = this.visibleImages.includes(image.id);
        });
        if (this.visibleImages.length > 0) {
            nextSort.sort((a, b)=>this.visibleImages.indexOf(a.id) - this.visibleImages.indexOf(b.id));
        }
        return nextSort; // [{ id, file, visible}, { .. }]
    }
    setTemperatureUnits(units = _temperatureUnitsEnum.default.CELSIUS) {
        this.temperatureUnits = units;
    }
    getSettings() {
        return _object_spread({}, this.settings || {});
    }
    getGroupImageData() {
        return _object_spread({}, this.groupImageData);
    }
    getPhotonotes() {
        var _this_photonotes;
        var _this_photonotes_slice;
        return (_this_photonotes_slice = (_this_photonotes = this.photonotes) === null || _this_photonotes === void 0 ? void 0 : _this_photonotes.slice()) !== null && _this_photonotes_slice !== void 0 ? _this_photonotes_slice : [];
    }
    getPaletteData() {
        return this.paletteData || DEFAULT_PALETTE_DATA;
    }
    getPaletteNames() {
        var _this_paletteData;
        return (((_this_paletteData = this.paletteData) === null || _this_paletteData === void 0 ? void 0 : _this_paletteData.paletteNames) || []).slice();
    }
    getPaletteGradient() {
        var _this_paletteData;
        return ((_this_paletteData = this.paletteData) === null || _this_paletteData === void 0 ? void 0 : _this_paletteData.paletteGradient) || "";
    }
    constructor(){
        this.temperatureUnits = _temperatureUnitsEnum.default.CELSIUS;
        this.loadedData = []; // Object[]
        this.groupImageData = {}; // String[]
        this.photonotes = []; // String[]
        this.settings = {};
        this.visibleImages = []; // String[]
        this.paletteData = DEFAULT_PALETTE_DATA;
    }
}
